import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EstateAddEdit, EstateListing } from './Pages'

export const EstateRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={EstateListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={EstateAddEdit} />
    </Fragment>
)